import { Phone, Mail, Facebook, Instagram } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { useLang } from "@/i18n";

const PARTNERS = [
  { name: "CH PRESS SA", href: "https://www.ch-press.ch/" },
  { name: "SECUREPOL SA", href: "https://securepol.ch/" },
  { name: "Portale Ticino Aziende", href: "https://ticinoaziende.ch/" },
];

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#08080B] pb-28 pt-16 md:pb-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <LogoMark size={42} />
              <span className="font-display text-sm font-extrabold tracking-[0.18em] text-white">
                TAXI BELLINZONA
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-500">{f.tagline}</p>
          </div>
          <div>
            <h4 className="font-mono-alt text-[11px] uppercase tracking-[0.3em] text-amber-400">
              {f.contacts}
            </h4>
            <div className="mt-5 space-y-4 text-sm">
              <a href="tel:+41766344242" data-testid="footer-phone-main" className="flex items-center gap-3 text-slate-300 transition-colors hover:text-amber-300">
                <Phone className="h-4 w-4 text-amber-400" /> +41 76 634 4242 — {f.central}
              </a>
              <a href="tel:+41912292464" data-testid="footer-phone-business" className="flex items-center gap-3 text-slate-300 transition-colors hover:text-amber-300">
                <Phone className="h-4 w-4 text-amber-400" /> +41 91 229 2464 — {f.business}
              </a>
              <a href="mailto:info@taxibellinzona.ch" data-testid="footer-email" className="flex items-center gap-3 text-slate-300 transition-colors hover:text-amber-300">
                <Mail className="h-4 w-4 text-amber-400" /> info@taxibellinzona.ch
              </a>
            </div>
          </div>
          <div>
            <h4 className="font-mono-alt text-[11px] uppercase tracking-[0.3em] text-amber-400">
              {f.follow}
            </h4>
            <div className="mt-5 flex gap-3">
              <a
                href="https://www.facebook.com/profile.php?id=61564864979714"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-slate-300 transition-all hover:border-amber-400 hover:text-amber-400"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/amm.taxibellinzona/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-slate-300 transition-all hover:border-amber-400 hover:text-amber-400"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
            <h4 className="mt-8 font-mono-alt text-[11px] uppercase tracking-[0.3em] text-slate-600">
              {f.media}
            </h4>
            <div className="mt-3 flex flex-wrap gap-x-5 gap-y-2 text-xs text-slate-500">
              {PARTNERS.map((p) => (
                <a key={p.name} href={p.href} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-amber-300">
                  {p.name}
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-slate-600 sm:flex-row sm:items-center">
          <span>© {new Date().getFullYear()} {f.rights}</span>
          <span className="font-mono-alt uppercase tracking-[0.25em]">{f.service24}</span>
        </div>
      </div>
    </footer>
  );
};
